<script>
import ChangeUserinfo from './components/ChangeUserinfo'

export default {
    components: {
        'change-userinfo': ChangeUserinfo,
    },
    data() {
        return {}
    },
}
</script>
